import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/layout/Logo";
import BookButton from "@/components/layout/BookButton";

const NAV = [
  { to: "/bachelor", label: "Bachelor" },
  { to: "/master", label: "Master" },
  { to: "/medicine-dentistry", label: "Medicine & Dentistry" },
  { to: "/phd", label: "PhD" },
  { to: "/english-exam", label: "English Exam" },
  { to: "/entry-exams", label: "Entry Exams" },
  { to: "/about", label: "About" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[#F8F7F4]/85 backdrop-blur-xl border-b border-[#E5E3D8]"
          : "bg-transparent"
      }`}
    >
      <div className="container-sp flex items-center justify-between h-20">
        <div className="flex items-center" data-testid="nav-logo-link">
          <Logo />
        </div>

        <nav className="hidden lg:flex items-center gap-1" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.to.replace("/", "")}`}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-full transition-colors ${
                  isActive
                    ? "text-[#0D1B2A] bg-[#EBE9E1]"
                    : "text-[#4A5568] hover:text-[#0D1B2A] hover:bg-[#EBE9E1]/60"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-2">
          <BookButton
            track="general"
            variant="primary"
            testId="nav-cta-consultation"
          >
            Book Consultation
          </BookButton>
        </div>

        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          className="lg:hidden p-2 rounded-full hover:bg-[#EBE9E1]"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden bg-[#F8F7F4] border-t border-[#E5E3D8]"
          data-testid="nav-mobile-menu"
        >
          <div className="container-sp py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                className={({ isActive }) =>
                  `px-3 py-3 text-base rounded-xl ${
                    isActive
                      ? "text-[#0D1B2A] bg-[#EBE9E1]"
                      : "text-[#4A5568]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <BookButton
              track="general"
              variant="primary"
              testId="nav-mobile-cta"
              className="justify-center mt-3"
            >
              Book Consultation
            </BookButton>
          </div>
        </div>
      )}
    </header>
  );
}
